import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { getProductData } from '../utils/getProductData';
import { useTrackQrScan } from '../hooks/useTrackQrScan';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import CertificateHeader from '../components/impact/CertificateHeader';
import InitiativeHero from '../components/impact/InitiativeHero';
import StoryBlock from '../components/impact/StoryBlock';
import PartnerCard from '../components/impact/PartnerCard';
import ImpactMetrics from '../components/impact/ImpactMetrics';
import RoadmapTimeline from '../components/impact/RoadmapTimeline';
import BenefitsList from '../components/impact/BenefitsList';
import ProductReferenceCard from '../components/impact/ProductReferenceCard';

function ProductDetail() {
  const { id } = useParams();

  useTrackQrScan(id);

  const data = useMemo(() => getProductData(id || 'default'), [id]);
  const { initiative, partner, impact, roadmap, product } = data;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #fafaf8 0%, #f5f5f0 100%)',
        py: { xs: 4, sm: 6, md: 8 },
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Navbar />

      <Container
        maxWidth="md"
        sx={{
          pt: { xs: 8, sm: 10 },
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            backgroundColor: 'rgba(255, 255, 255, 0.55)',
            border: '1px solid rgba(74, 106, 74, 0.15)',
            borderRadius: { xs: 4, sm: 6 },
            boxShadow: '0 30px 80px rgba(74, 106, 74, 0.08)',
            p: { xs: 2.5, sm: 5, md: 7 },
            overflow: 'hidden',
          }}
        >
          <Box sx={{ position: 'relative' }}>
            <CertificateHeader />
            <InitiativeHero initiative={initiative} />
            <StoryBlock summary={initiative?.summary} story={initiative?.story} />
            <PartnerCard partner={partner} />
            <ImpactMetrics metrics={impact?.metrics} partnerName={partner?.name} />
            <RoadmapTimeline roadmap={roadmap} />
            <BenefitsList benefits={impact?.benefits} />
            <ProductReferenceCard product={product} />
          </Box>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
}

export default ProductDetail;
